import ApiClient from '../../../../base/api';
import { FileToUpload } from '../../../../base/components/Forms/FileUpload';
import { SortDirection } from '../../../../base/enums';
import { RecommendationsWithProfiles, UpgradePackage } from '../interfaces';
import {
    GetVacancyListParams,
    PublishVacancyRequestParams,
    PublishVacancyResponse,
    UpdateVacancyRequestParams,
    UpgradeVacancyParams,
    UpgradeVacancyResponseDTO,
    VacancyListItem,
    VacancyResponseDTO,
    ValidateVacancyRequestParams,
} from './interfaces';

const apiClient = new ApiClient();

export const vacancyApi = {
    getVacancyList: ({ search, status, sort, page }: GetVacancyListParams) => {
        let path = `/api/vacancy?${search ? `search=${search}&` : ''}${status ? `status=${status}&` : ''}${
            sort ? `sort=${sort.direction === SortDirection.Asc ? sort.column : `-${sort.column}`}&` : ''
        }${page ? `page=${page}` : ''}`;
        if (path.endsWith('&') || path.endsWith('?')) {
            path = path.slice(0, path.length - 1);
        }
        return apiClient.get<VacancyListItem[]>(path);
    },
    getVacancyDataById: (vacancyId: string) => apiClient.get<VacancyResponseDTO>(`/api/vacancy/${vacancyId}`),
    validateStep: (data: ValidateVacancyRequestParams) => apiClient.post('/api/vacancy', { ...data, validate: true }),
    publishVacancy: (data: PublishVacancyRequestParams) =>
        apiClient.post<PublishVacancyRequestParams, PublishVacancyResponse>('/api/vacancy', data),
    updateVacancy: ({ id, data }: UpdateVacancyRequestParams) =>
        apiClient.put<PublishVacancyRequestParams, PublishVacancyResponse>(`/api/vacancy/${id}`, data),
    saveImages: (vacancyId: string, files: FileToUpload[]) => {
        const formData = new FormData();
        files.forEach((item) => {
            formData.append('VacancyImagesUpload[images][]', item.file);
        });

        return apiClient.post<FormData, void>(`/api/vacancy/${vacancyId}/images`, formData, {
            headers: {
                'Content-type': 'multipart/form-data',
            },
        });
    },
    deleteImageById: (vacancyId: string, imageId: number) =>
        apiClient.delete(`/api/vacancy/${vacancyId}/images/${imageId}`),
    closeVacancy: (vacancyId: string) => apiClient.post(`/api/vacancy/${vacancyId}/close`),
    openVacancy: (vacancyId: string) => apiClient.post(`/api/vacancy/${vacancyId}/open`),
    renewVacancy: (vacancyId: string) => apiClient.post(`/api/vacancy/${vacancyId}/renew`),
    upgradeVacancy: (vacancyId: string, data: UpgradeVacancyParams) =>
        apiClient.post<UpgradeVacancyParams, UpgradeVacancyResponseDTO>(`/api/vacancy/${vacancyId}/upgrade`, data),
    getTarrifs: () => apiClient.get<UpgradePackage[]>('/api/vacancy/tariffs'),
    getRecommendations: (vacancyId: string) =>
        apiClient.get<RecommendationsWithProfiles>(`/api/vacancy/${vacancyId}/recommendations`),
    inviteWorkerForVacancy: (vacancyId: number, workerId: number) =>
        apiClient.post<{ workerId: number }, void>(`/api/vacancy/${vacancyId}/invite`, { workerId }),
};
